/* Display complete Judge.me rating data, never a distribution inferred from the current page. */
(() => {
 if (window.bcRatingSummary) { window.bcRatingSummary.connect(); return; }
 const instances = new Map();
 function connect() {
  document.querySelectorAll('[data-bc-rating-section]').forEach(root => {
   if (instances.has(root)) return;
   const panel = root.querySelector('[data-bc-rating-summary]');
   if (!panel) return;
   const state = {signature: '', attempts: 0, frame: 0};
   function update() {
    const host = root.querySelector('.jdgm-widget[data-product-id]');
    const data = window.jdgm?.data?.reviewWidget?.[host?.dataset.productId];
    const average = Number(data?.average_rating);
    const total = Number(data?.number_of_reviews);
    const histogram = data?.histogram;
    if (!Number.isFinite(average) || average < 0 || average > 5 || !Number.isInteger(total) || total <= 0 || !Array.isArray(histogram)) return;
    const rows = [5,4,3,2,1].map(rating => ({rating, count: Number(histogram.find(row => Number(row.rating) === rating)?.frequency)}));
    if (rows.some(row => !Number.isInteger(row.count) || row.count < 0) || rows.reduce((sum,row) => sum+row.count,0) !== total) return;
    const signature = JSON.stringify({average,total,rows});
    if (signature === state.signature) return;
    state.signature = signature;
    const format = new Intl.NumberFormat(document.documentElement.lang || 'en-IN');
    panel.querySelector('[data-bc-rating-average]').textContent = average.toFixed(1);
    panel.querySelector('[data-bc-rating-count]').textContent = `${format.format(total)} reviews`;
    const stars = panel.querySelector('[data-bc-rating-stars]');
    stars.setAttribute('aria-label', `${average} out of 5 stars`);
    stars.style.setProperty('--bc-rating-fill', `${average/5*100}%`);
    const list = panel.querySelector('[data-bc-rating-bars]');
    const fragment = document.createDocumentFragment();
    rows.forEach(({rating,count}) => {
     const row = document.createElement('li'); row.className = 'bc-rating-summary__row';
     row.setAttribute('aria-label', `${rating} stars: ${format.format(count)} reviews`);
     const label = document.createElement('span'); label.className = 'bc-rating-summary__label'; label.textContent = rating;
     const star = document.createElement('span'); star.className = 'bc-rating-summary__star'; star.textContent = '★'; star.setAttribute('aria-hidden','true'); label.append(star);
     const track = document.createElement('span'); track.className = 'bc-rating-summary__track'; track.setAttribute('aria-hidden','true');
     const fill = document.createElement('span'); fill.className = 'bc-rating-summary__fill'; fill.style.width = `${count/total*100}%`; track.append(fill);
     const amount = document.createElement('span'); amount.className = 'bc-rating-summary__count'; amount.textContent = `(${format.format(count)})`;
     if (!count) amount.classList.add('bc-rating-summary__count--empty');
     row.append(label,track,amount); fragment.append(row);
    });
    list.replaceChildren(fragment); panel.hidden = false; root.classList.add('bc-rating-summary-ready');
    clearInterval(state.timer);
   }
   const schedule = () => { if (!state.frame) state.frame = requestAnimationFrame(() => { state.frame=0; update(); }); };
   state.observer = new MutationObserver(schedule);
   state.observer.observe(root,{childList:true,subtree:true});
   state.timer = setInterval(() => { update(); if (++state.attempts >= 30) clearInterval(state.timer); },1000);
   instances.set(root,state); update();
  });
 }
 document.addEventListener('shopify:section:load',connect);
 document.addEventListener('shopify:section:unload',event => {
  for (const [root,state] of instances) if (event.target.contains(root)) {state.observer.disconnect();clearInterval(state.timer);cancelAnimationFrame(state.frame);instances.delete(root);}
 });
 window.bcRatingSummary={connect};
 if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',connect,{once:true}); else connect();
})();
